




export default {
  name: 'Spinner'
  props: [
    'is_active'
  ]
  mounted: () ->
    componentHandler.upgradeElements @$el
}




// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/elements/Spinner.vue